/**
 * PFAP Hub — Guide Mode (Phase 1) sidebar toggle.
 *
 * Tiny, accessible ON/OFF control. Mounted in the sidebar bottom area
 * just above the Change Password / Logout buttons. Hides when Guide
 * Mode prefs haven't loaded yet so it doesn't flicker into the wrong
 * state.
 */
import React from 'react';
import { useGuideMode } from '../contexts/GuideModeContext';
import { BookOpen, BookOpenCheck } from 'lucide-react';
import { Button } from './ui/button';

const GuideToggle = ({ collapsed }) => {
  const { guide_mode_enabled, loading, setEnabled } = useGuideMode();
  if (loading) return null;
  const on = !!guide_mode_enabled;
  const Icon = on ? BookOpenCheck : BookOpen;

  return (
    <Button
      variant="ghost"
      onClick={() => setEnabled(!on)}
      title={on ? 'Guide Mode is ON — click to turn off' : 'Guide Mode is OFF — click to turn on'}
      aria-pressed={on}
      data-testid="guide-mode-toggle"
      data-state={on ? 'on' : 'off'}
      className={`w-full ${
        on
          ? 'text-emerald-700 dark:text-emerald-400 hover:text-emerald-800 dark:hover:text-emerald-300'
          : 'text-gray-500 dark:text-gray-500 hover:text-gray-900 dark:hover:text-gray-200'
      } hover:bg-gray-100 dark:hover:bg-gray-700 h-9 ${collapsed ? 'px-0 justify-center' : ''}`}
    >
      <Icon size={18} />
      {!collapsed && (
        <span className="ml-2.5 text-sm flex items-center gap-1.5 truncate">
          Guide Mode
          <span
            className={`text-[10px] px-1.5 py-0.5 rounded-full border ${
              on
                ? 'bg-emerald-100 border-emerald-200 text-emerald-700 dark:bg-emerald-900/40 dark:border-emerald-800 dark:text-emerald-300'
                : 'bg-gray-100 border-gray-200 text-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400'
            }`}
            data-testid="guide-mode-toggle-state"
          >
            {on ? 'ON' : 'OFF'}
          </span>
        </span>
      )}
    </Button>
  );
};

export default GuideToggle;
